(function ($) {
    const conditionalFields = $('[data-conditional-field]');
    conditionalFields.each(function () {
        const condField = $(this);
        const settings = JSON.parse(condField.attr('data-conditional-field'));

        const {
            is_toggleable,
            conditional_field_name,
            conditional_field_value,
            conditional_field_condition,
        } = settings;

        if (condField.is('select')) {
            condField.on('select2:select', function (e) {
                condField.addClass('selected');
                handlePolicyShow();
            });
        }

        if (is_toggleable) {
            const condSelectEl = $(`select[name="${conditional_field_name}"]`);
            const condSelectElValue = condSelectEl.val();

            condSelectEl.on('select2:select', function (e) {
                condSelectEl.addClass('selected');

                if (condField.is('select')) {
                    const options = condField.find('option');
                }

                const selVal = $(this).val();
                checkConditionalSelect(
                    condField,
                    conditional_field_value,
                    conditional_field_condition,
                    selVal
                );
            });

            checkConditionalSelect(
                condField,
                conditional_field_value,
                conditional_field_condition,
                condSelectElValue
            );
        }
    });

    function modifyFormDataConditionals(formData) {
        conditionalFields.each(function () {
            const condField = $(this);
            const settings = JSON.parse(
                condField.attr('data-conditional-field')
            );

            const {
                is_toggleable,
                conditional_field_name,
                conditional_field_value,
                conditional_field_condition,
            } = settings;

            if (is_toggleable) {
                const condSelectEl = $(
                    `select[name="${conditional_field_name}"]`
                );
                const condSelectElValue = condSelectEl.val();

                checkFormDataConditionals(
                    formData,
                    condField,
                    conditional_field_value,
                    conditional_field_condition,
                    condSelectElValue
                );
            }
        });
    }

    let mapInsance = null;
    let infoWindow = null;
    let marker = null;

    const handleMap = async () => {
        const hiddenMapInput = document.querySelector('[data-form-map-input]');
        if (mapInsance === null){
            const map = document.querySelector('[data-form-map]');
            const mapId = map.getAttribute("data-map-id");
            const position = {lat: 52.423956, lng: 18.4661922};
            const { Map } = await google.maps.importLibrary("maps");
            const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

            mapInsance = new Map(map, {
                zoom: 6,
                center: position,
                mapId: mapId || "83fd182ae16cb0d9",
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false
            });

            mapInsance.addListener("click", (mapsMouseEvent) => {
                // Close the current InfoWindow.
                if (marker) {
                    marker.setMap(null);
                }

                marker = new AdvancedMarkerElement({
                    position: mapsMouseEvent.latLng,
                    map: mapInsance
                })
                marker.content = createIcon();

                marker.addListener("click",() => {
                    marker.setMap(null);
                    hiddenMapInput.value = ""; 
                })

                hiddenMapInput.value = JSON.stringify(mapsMouseEvent.latLng.toJSON()); 
                
              });
        } 
    }

    function createIcon() {
        const icon = document.createElement("img");
        icon.width = 28;
        icon.src =  '/app/themes/main/dist/img/gmaps/unactive-pin.png';

        return icon;
    }

    function checkFormDataConditionals(
        formData,
        field,
        fieldValue,
        condition,
        selectValue
    ) {
        const fieldName = field.attr('name');

        if (condition === 'equal' && selectValue !== fieldValue)
            formData.delete(fieldName);

        if (condition === 'not_equal' && selectValue === fieldValue)
            formData.delete(fieldName);
    }

    function checkConditionalSelect(field, fieldValue, condition, selectValue) {
        const fieldWrapper = field.closest('.form__field');
        const fieldWrapperSiblings = fieldWrapper.siblings();

        if (condition === 'equal') {
            if (selectValue === fieldValue) {
                field.closest('.form__field').removeClass('hidden');
                field.closest('.form__col').removeClass('hidden');
                if (field[0].getAttribute("data-form-map-input")) {
                    handleMap();
                }

            } else {
                field.closest('.form__field').addClass('hidden');

                // check siblings, when 0, then hide column
                if (fieldWrapperSiblings.length === 0) {
                    field.closest('.form__col').addClass('hidden');
                }
            }
        }

        if (condition === 'not_equal') {
            if (selectValue?.length >= 0 && selectValue !== fieldValue) {
                field.closest('.form__field').removeClass('hidden');
                field.closest('.form__col').removeClass('hidden');
            } else {
                field.closest('.form__field').addClass('hidden');

                // check siblings, when 0, then hide column
                if (fieldWrapperSiblings.length === 0) {
                    field.closest('.form__col').addClass('hidden');
                }
            }
        }
    }

    /// Newsletter policy array functionaliy

    const newsletterPolicyEl = document.querySelector(
        '.form__newsletter-policy-array'
    );

    const handlePolicyShow = () => {
        if (!newsletterPolicyEl) return;
        const policyItems = newsletterPolicyEl.querySelectorAll(
            '.form__newsletter-policy-item'
        );
        if (!policyItems || policyItems.length === 0) return;
        const form = document.querySelector('.js-cf-form--newsletter');
        if (!form) return;
        const formElements = form.elements;
        if (!formElements) return;

        policyItems.forEach(item => item.classList.add('d-none'));

        policyItems.forEach(item => {
            const settings = JSON.parse(item.getAttribute('data-settings'));
            const conditionsLength = settings.length;
            let metConditions = 0;
            Array.from(formElements).forEach(element => {
                const { name, value } = element;
                settings.filter(setting => {
                    const { condition } = setting;
                    if (condition === 'equal') {
                        if (setting.name === name && setting.value === value) {
                            metConditions = metConditions + 1;
                        }
                    } else if (condition === 'not_equal') {
                        if (setting.name === name && setting.value !== value) {
                            metConditions = metConditions + 1;
                        }
                    }
                });
            });
            if (conditionsLength === metConditions) {
                item.classList.remove('d-none');
            }
        });
    };

    if (newsletterPolicyEl) {
        const policyItems = newsletterPolicyEl.querySelectorAll(
            '.form__newsletter-policy-item'
        );

        if (policyItems?.length > 0) {
            handlePolicyShow();
        }
    }

    let alertInsance = null;

    $('.js-cf-form').on('submit', function (e) {
        e.preventDefault();

        const $form = $(this);
        let data = $form.serialize();
        const alertWrapper = $form[0].querySelector('.form-alert');
        const outputWrapper = $form[0].querySelector(".form__output-wrapper");

        if (outputWrapper) {
            outputWrapper.textContent = "";
            outputWrapper.classList.remove("warning");
            outputWrapper.classList.remove("success");
            outputWrapper.classList.remove("error");
        }

        $form.addClass('is-loading');

        const recaptchaKey = $form.find('#g-recaptcha').val();
        const formId = $form.attr('id');
        let formObject = document.getElementById(formId);
        const formData = new FormData(formObject);
        modifyFormDataConditionals(formData);

        const filesToUpload = $form.find('[type="file"]');

        grecaptcha.ready(function () {
            grecaptcha
                .execute(recaptchaKey, { action: 'submit' })
                .then(function (token) {
                    formData.append('g_recaptcha_token', token);

                    if (alertInsance) {
                        alertInsance.handleAlertClasses();
                    }

                    $.ajax({
                        type: 'post',
                        url: ajax.url,
                        data: formData,
                        processData: false,
                        contentType: false,
                        beforeSend: function () {
                            $('.js-cf-error').remove();
                            $('.form-field').removeClass('error');
                            $form
                                .find('.js-form-output')
                                .removeClass(
                                    'has-errors is-warning is-success'
                                );

                            $('.js-cf-form__status').removeClass('success');
                            $('.js-cf-form__status').hide();
                            $('.js-cf-form__status span').html('');
                        },
                        success: function (response) {
                            response = $.parseJSON(response);

                            if (response.status == 'ERROR') {
                                if (outputWrapper) {
                                    outputWrapper.classList.add(response.status.toLowerCase());
                                    outputWrapper.textContent = response.errors.form;
                                }
                                $.each(
                                    response.errors.fields,
                                    function (key, value) {
                                        const $parent = $form
                                            .find(`[name="${key}"]`)
                                            .parents('.form-field');
                                        $parent.addClass('error');
                                        $parent.append(
                                            `<div class='js-cf-error form-error'>${value}</div>`
                                        );

                                        if (marker) marker.setMap(null);

                                        const multipleParent = $form // check for inputs with multiple values (eg. files)
                                            .find(`[name="${key}[]"]`)
                                            .parents('.form-field');

                                        multipleParent.addClass('error');
                                        multipleParent.append(
                                            `<div class='js-cf-error form-error'>${value}</div>`
                                        );
                                    }
                                );

                                const alert_data = {
                                    type: 'alert:show',
                                    title: response.errors.form,
                                    error: true,
                                };
                                $('body').trigger(alert_data);
                            } else if (response.status == 'WARNING') {
                                if (outputWrapper) {
                                    outputWrapper.classList.add(response.status.toLowerCase());
                                    outputWrapper.textContent = response.errors.send_mail;
                                }
                                $form
                                    .find(':input:not([type=hidden]):not(:checkbox):not(select)')
                                    .val('');
                                $form.find('textarea').val('');
                                $form.find('input[type="checkbox"]').prop('checked', false);

                                const files = document.querySelectorAll('[data-file]');
                                if (files.length > 0) {
                                    files.forEach(item => {
                                        const defaultMessage = item.getAttribute("data-default-message");
                                        const textWrapper = item.querySelector(".form-file__uploadStatus span");
                                        textWrapper.textContent = defaultMessage;
                                    });
                                }
                                
                                if (marker) marker.setMap(null);

                                const alert_data = {
                                    type: 'alert:show',
                                    title: response.save_form,
                                };
                                $('body').trigger(alert_data);
                            } else {
                                if (outputWrapper) {
                                    outputWrapper.classList.add(response.status.toLowerCase());
                                    outputWrapper.textContent = response.status_msg ? response.status_msg : response.send_mail;
                                }
                                $form
                                    .find(':input:not([type=hidden]):not(:checkbox):not(select)')
                                    .val('');
                                $form.find('textarea').val('');
                                $form.find('input[type="checkbox"]').prop('checked', false);

                                const files = document.querySelectorAll('[data-file]');
                                if (files.length > 0) {
                                    files.forEach(item => {
                                        const defaultMessage = item.getAttribute("data-default-message");
                                        const textWrapper = item.querySelector(".form-file__uploadStatus span");
                                        textWrapper.textContent = defaultMessage;
                                    });
                                }
                                
                                if (marker) marker.setMap(null);

                                const alert_data = {
                                    type: 'alert:show',
                                    title: '!23',
                                    success: true,
                                };
                                $('body').trigger(alert_data);

                                $('.js-cf-form__status').addClass('success');
                                $('.js-cf-form__status').show();
                                $('.js-cf-form__status span').html(
                                    response.status_msg
                                );
                            }
                            $form.removeClass('is-loading');
                        },
                    });
                });
        });
    });
})(jQuery);
